import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    paymentTypeList: [
      {
        id: 1,
        name: '货到付款'
      },
      {
        id: 2,
        name: '款到发货'
      },
      {
        id: 3,
        name: '预售部分发货'
      }
    ],
    navList: [
      {
        name: '账号管理',
        pathId: 'accoutlist',
        hasChild: true,
        id: '2',
        childrenList: [
          {
            name: '账号列表',
            pathId: 'accoutlist',
            id: 'accoutlist'
          }
        ]
      },
      {
        name: '角色管理',
        pathId: 'userlist',
        hasChild: true,
        id: '3',
        childrenList: [
          {
            name: '角色列表',
            pathId: 'userlist',
            id: 'userlist'
          }
        ]
      },
      {
        name: '公司管理',
        pathId: 'companylist',
        hasChild: true,
        id: '4',
        childrenList: [
          {
            name: '公司列表',
            pathId: 'companylist',
            id: 'companylist'
          }
        ]
      },
      // {
      //   name: '联系人管理',
      //   pathId: 'contactlist',
      //   hasChild: true,
      //   id: '5',
      //   childrenList: [
      //     {
      //       name: '联系人列表',
      //       pathId: 'contactlist',
      //       id: 'contactlist'
      //     }
      //   ]
      // },
      {
        name: '商品管理',
        pathId: 'goodslist',
        hasChild: true,
        id: '6',
        childrenList: [
          {
            name: '商品分类列表',
            pathId: 'goodstype',
            id: 'goodstype'
          },
          {
            name: '商品列表',
            pathId: 'goodslist',
            id: 'goodslist'
          },
        ]
      },
      {
        name: '票货管理',
        pathId: 'shiplist',
        hasChild: true,
        id: '7',
        childrenList: [
          {
            name: '票货列表',
            pathId: 'shiplist',
            id: 'shiplist'
          }
        ]
      },
      {
        name: '仓储管理',
        pathId: 'stocklist',
        hasChild: true,
        id: '8',
        childrenList: [
          // {
          //   name: '库位列表',
          //   pathId: 'stocklist',
          //   id: 'stocklist'
          // },
          {
            name: '库存列表',
            pathId: 'kclist',
            id: 'kclist'
          }
        ]
      },
      {
        name: '订单管理',
        pathId: 'orderlist',
        hasChild: true,
        id: '9',
        childrenList: [
          {
            name: '采购订单列表',
            pathId: 'buyorderlist',
            id: 'buyorderlist'
          },
          {
            name: '销售订单列表',
            pathId: 'orderlist',
            id: 'orderlist'
          }
        ]
      },
      {
        name: '补货管理',
        pathId: 'replenishmentList',
        hasChild: true,
        id: '10',
        childrenList: [
          {
            name: '补货列表',
            pathId: 'replenishmentList',
            id: 'replenishmentList'
          },
          {
            name: '不补货列表',
            pathId: 'noreplenishmentlist',
            id: 'noreplenishmentlist'
          },
          {
            name: '补货统计',
            pathId: 'totallist',
            id: 'totallist'
          },
        ]
      },
      {
        name: '收款管理',
        pathId: 'ticketList',
        hasChild: true,
        id: '11',
        childrenList: [
          {
            name: '开票列表',
            pathId: 'ticketList',
            id: 'ticketList'
          },
        ]
      },
      {
        name: '月结算管理',
        pathId: 'monthList',
        hasChild: true,
        id: '12',
        childrenList: [
          {
            name: '月结算基础信息',
            pathId: 'monthinfo',
            id: 'monthinfo'
          },
          {
            name: '月结费',
            pathId: 'monthmoney',
            id: 'monthmoney'
          },
          {
            name: '月结算记录列表',
            pathId: 'monthList',
            id: 'monthList'
          },
        ]
      },
      {
        name: '利润图表',
        pathId: 'rateList',
        hasChild: true,
        id: '13',
        childrenList: [
          {
            name: '半年汇率',
            pathId: 'rateList',
            id: 'rateList'
          },
          {
            name: '销售利润',
            pathId: 'profit',
            id: 'profit'
          },
        ]
      }
    ],
    processMode: [ //  处理方式
      {
        id: 1,
        name: '立即补货'
      },
      {
        id: 2,
        name: '下一单补货'
      }
    ],
    returnReason: [ //  退货原因
      {
        id: 1,
        name: '破包'
      },
      {
        id: 2,
        name: '不合格'
      }
    ],
    returnWarehouse: [ //  是否退回
      {
        id: 'T',
        name: '退回仓库'
      },
      {
        id: 'F',
        name: '不退回仓库'
      }
    ],
  },
  getters: {
    getNavList: (state) => {
      return state.navList
    },
    getpaymentTypeList: (state) => {
      return state.paymentTypeList
    },
    getprocessMode: (state) => {
      return state.processMode
    },
    getreturnReason: (state) => {
      return state.returnReason
    },
    getreturnWarehouse: (state) => {
      return state.returnWarehouse
    },
  },
  mutations: {
  },
  actions: {

  }
})
